if (!customElements.get("flickity-reviews")) {
  customElements.define(
    "flickity-reviews",
    class FlickityReviews extends window.FlickityCarouselBase {
      observeResize() {
        return true;
      }

      _cellsPerPage(mode) {
        return mode === "mobile" ? 1 : 4;
      }

      _setCellPixelWidths(mode) {
        const sliderWidth = this.offsetWidth;
        if (!sliderWidth) return;
        const cells = Array.from(this.querySelectorAll(".reviews__cell"));
        // Desktop: 4 cells per row. Mobile: ~1 cell with a small prev/next peek.
        const cellWidth = mode === "desktop" ? sliderWidth / 4 : sliderWidth * 0.88;
        cells.forEach((c) => {
          c.style.width = `${cellWidth}px`;
          c.style.flexBasis = `${cellWidth}px`;
        });
      }

      beforeInit(mode) {
        this._setCellPixelWidths(mode);
      }

      getFlickityOptions(mode) {
        return {
          cellSelector: ".reviews__cell",
          cellAlign: "left",
          contain: true,
          pageDots: mode === "mobile",
          prevNextButtons: false,
          groupCells: this._cellsPerPage(mode),
          freeScroll: false,
          wrapAround: mode === "mobile",
          dragThreshold: 10,
          accessibility: true,
          // Off: imagesLoaded proxies every <img> through `new Image()`, which
          // downloads lazy and hidden-tab images up front. Media boxes have fixed
          // aspect ratios, so cell heights never depend on the images.
          imagesLoaded: false,
        };
      }

      afterInit(_mode) {
        this.flickity.on("change", () => this._updateDotsWindow());
        this._updateDotsWindow();
      }

      onResize(mode) {
        this._setCellPixelWidths(mode);
      }

      // Keep the mobile dot strip to a fixed window (matches the design's 4 dots).
      _updateDotsWindow() {
        const MAX = 5;
        const dots = Array.from(this.querySelectorAll(".flickity-page-dots .dot"));
        if (dots.length === 0) return;

        if (this._currentMode !== "mobile" || dots.length <= MAX) {
          dots.forEach((d) => (d.style.display = ""));
          return;
        }

        const active = this.flickity?.selectedIndex ?? 0;
        const cycledActive = active % MAX;

        dots.forEach((d, i) => {
          if (i < MAX) {
            d.style.display = "";
            d.classList.toggle("is-selected", i === cycledActive);
          } else {
            d.style.display = "none";
            d.classList.remove("is-selected");
          }
        });
      }
    },
  );
}
